// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6c7fd2992c8b4aa814ab","655":"6dc74071455df8d8dd04"}[chunkId] + ".js";
};